import { render } from "./serviceBannerComponent.vue?vue&type=template&id=195641a2"
import script from "./serviceBannerComponent.vue?vue&type=script&lang=js"
export * from "./serviceBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__